var render = function () {
  var _vm$setting, _vm$setting$startup, _vm$setting2, _vm$setting2$startup;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "src": "/images/sub/sub-visual-pitching-festa.jpg"
          },
          scopedSlots: _vm._u([{
            key: "titleContents",
            fn: function fn() {
              return [_c('div', {
                staticClass: "sub-visual__tit-wrap mt-lg-n20px"
              }, [_c('h2', {
                staticClass: "sub-visual__tit"
              }, [_c('span', {
                staticClass: "font-size-lg-100 font-weight-bold"
              }, [_vm._v("e")]), _vm._v("커머스피칭페스타 스타트업")])])];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--sm"
  }, [_c('v-layout', {
    staticClass: "text-center",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit tit--xl"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s((_vm$setting = _vm.setting) === null || _vm$setting === void 0 ? void 0 : (_vm$setting$startup = _vm$setting.startup) === null || _vm$setting$startup === void 0 ? void 0 : _vm$setting$startup.title))])])]), _c('v-card', {
    attrs: {
      "color": "w-100 grey lighten-5",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "pa-16px pa-md-24px"
  }, [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-select', {
    staticClass: "v-input--small w-100 w-md-120px",
    attrs: {
      "items": _vm.searchKeys,
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "v-input--small w-100 w-md-400px",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "placeholder": "검색어를 입력하세요."
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "grey"
    },
    on: {
      "click": function click($event) {
        return _vm.search(false);
      }
    }
  }, [_vm._v("검색")])], 1)], 1)], 1)]), _c('div', {
    staticClass: "mt-16px mt-md-24px w-100 hash-wrap",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-btn-toggle', {
    staticClass: "v-btn-toggle--primary justify-center",
    attrs: {
      "group": "",
      "multiple": ""
    },
    model: {
      value: _vm.filter.hashTags,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "hashTags", $$v);
      },
      expression: "filter.hashTags"
    }
  }, _vm._l((_vm$setting2 = _vm.setting) === null || _vm$setting2 === void 0 ? void 0 : (_vm$setting2$startup = _vm$setting2.startup) === null || _vm$setting2$startup === void 0 ? void 0 : _vm$setting2$startup.hashTags, function (hashTag, index) {
    return _c('v-btn', {
      key: index,
      attrs: {
        "value": hashTag
      }
    }, [_vm._v("#" + _vm._s(hashTag))]);
  }), 1)], 1), _c('div', {
    staticClass: "btn-wrap btn-wrap--sm",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed hash-btn",
    attrs: {
      "color": "grey",
      "dark": ""
    }
  }, [_vm.showText ? _c('span', {
    staticClass: "d-flex align-center justify-space-between w-100"
  }, [_vm._v("더 보기 "), _c('v-icon', {
    staticClass: "font-size-18"
  }, [_vm._v("mdi-plus")])], 1) : _c('span', {
    staticClass: "d-flex align-center justify-space-between w-100"
  }, [_vm._v("닫기 "), _c('v-icon', {
    staticClass: "font-size-18"
  }, [_vm._v("mdi-minus")])], 1)])], 1)], 1)], 1), _c('page-section', {
    staticClass: "page-section--last  page-section--sm grey lighten-5"
  }, [_c('div', {
    staticClass: "tab-wrap",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('u-tabs', _vm._l(_vm.categories, function (category, index) {
    return _c('u-tab', {
      key: index,
      on: {
        "click": function click($event) {
          _vm.filter.category = category, _vm.search(true);
        }
      }
    }, [_vm._v(" " + _vm._s(category) + " ")]);
  }), 1)], 1), _c('v-divider', {
    staticClass: "grey darken-4 mb-20px mb-md-32px",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _c('v-row', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, _vm._l(_vm.startups, function (startup, index) {
    var _startup$thumb;
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": "3"
      }
    }, [_c('card-board', {
      attrs: {
        "imageBoard": "",
        "src": startup === null || startup === void 0 ? void 0 : (_startup$thumb = startup.thumb) === null || _startup$thumb === void 0 ? void 0 : _startup$thumb.src,
        "to": "/pitching-festa/startup/".concat(startup === null || startup === void 0 ? void 0 : startup._id),
        "chip": startup === null || startup === void 0 ? void 0 : startup.awardName,
        "title": startup === null || startup === void 0 ? void 0 : startup.name,
        "text": startup === null || startup === void 0 ? void 0 : startup.description,
        "view": String(startup === null || startup === void 0 ? void 0 : startup.viewCount)
      },
      scopedSlots: _vm._u([{
        key: "hash",
        fn: function fn() {
          return [_c('v-row', {
            staticClass: "row--xs"
          }, _vm._l(startup === null || startup === void 0 ? void 0 : startup.hashTags, function (hashTag, index) {
            return _c('v-col', {
              key: index,
              attrs: {
                "cols": "auto"
              }
            }, [_c('span', {
              staticClass: "txt txt--xs primary--text"
            }, [_vm._v("#" + _vm._s(hashTag))])]);
          }), 1)];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 1), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }